module.exports = __webpack_public_path__ + "e4d2b8f64e0de88d4945f9cf7191a683.svg";